import { createFileRoute } from '@tanstack/react-router'
import {
  LandingHeader,
  LandingHero,
  LandingStats,
  LandingIntroduce,
  LandingHowItWorks,
  LandingComparison,
  LandingPricing,
  LandingCTA,
  LandingFAQ,
  LandingFooter,
} from '../components/landing'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden font-sans">
      <LandingHeader />
      <LandingHero />
      <LandingStats />
      <LandingIntroduce />
      <LandingHowItWorks />
      <LandingComparison />
      <LandingPricing />
      <LandingCTA />
      <LandingFAQ />
      <LandingFooter />
    </div>
  )
}
